import { jsx } from "react/jsx-runtime";
import { Component } from "@contember/binding";
import { LayoutRenderer } from "../LayoutRenderer.js";
import { DataGridContainer } from "../../collections/DataGrid/base/DataGridContainer/DataGridContainer.js";
const DataGridPageRenderer = Component(
  ({
    children,
    side,
    title,
    navigation,
    headingProps,
    actions,
    layout,
    pageContentLayout,
    afterTitle,
    ...entityListProps
  }) => /* @__PURE__ */ jsx(
    LayoutRenderer,
    {
      side,
      title,
      afterTitle,
      navigation,
      actions,
      headingProps,
      layout,
      pageContentLayout,
      children: /* @__PURE__ */ jsx(DataGridContainer, { ...entityListProps, children })
    }
  ),
  "ListRenderer"
);
export {
  DataGridPageRenderer
};
//# sourceMappingURL=DataGridPageRenderer.js.map
